'use strict';

namespace Core {

    class ModalTransferDetails {

        transfers: any;
        passengers: any = { adults : 0, children : 0 };
        show: boolean = false;
        details: any = [];

        constructor(
            private $scope: ng.IScope,
            private broker: any,
            private $filter: any)
        {
        }

        init (container : ng.IAugmentedJQuery) {
            this.broker.subscribe('modalTransferDetails', 'showModalTransferDetails', e => {
                this.show = true;
            });

            this.$scope.$on('$destroy', () => {
                this.broker.unsubscribe('modalTransferDetails');
            });

            if(this.transfers) {
                this.passengers = {
                    adults: this.transfers.Details.Adults || 0,
                    children: this.transfers.Details.ChildAges ? this.transfers.Details.ChildAges.length : 0
                };

                this.details = ['Outbound', 'Inbound'].map( direction => {
                    const itinerary = this.transfers.Details.Itinerary;
                    return {
                        Direction : direction,
                        Departure: _.get(itinerary,`[${direction}Leg].DeparturePoint`,''),
                        DepartureDate: this.$filter('date')(
                            _.get(itinerary,`[${direction}Leg].DepartureDate`,''), 'EEE d MMM yyyy, hh:mm'),
                        Destination: _.get(itinerary,`[${direction}Leg].DestinationPoint`,''),
                        FlightDate: this.$filter('date')(
                            _.get(itinerary,`[${direction}Leg].FlightDate`,''), 'EEE d MMM yyyy, hh:mm'),
                        TransferType: _.get(itinerary,`[${direction}Leg].TransferType`,'')
                    };
                });
            }
        }

    }

    angular
        .module('core')
        .directive('modalTransferDetails', (): ng.IDirective => {

        return {
            scope: {},
            controller: ModalTransferDetails,
            controllerAs: 'mtd',
            templateUrl: 'partials/home/directivetemplate?type=TransferDetails',
            bindToController : {
                transfers : '='
            },
            link: function (scope : ng.IScope, el : ng.IAugmentedJQuery, attr, controller : ModalTransferDetails) {
                controller.init(el);
            }

        };

    });

}
